import { useEffect, useState } from 'react'
import client, { Query } from '../api'
import Cookie from 'js-cookie'
import useRouter from './useRouter'

export default () => {
  const [user, setUser] = useState()

  const runQuery = async () => {
    try {
      const { data } = await client.query({ query: Query.ME })
      if (!data?.me) {
        Cookie.remove('token')
        window.location = '/'
        return
      }
      setUser(data.me)
    } catch (e) {
      // An invalid/expired token makes ME fail with "Not Authorised!" (it throws
      // rather than returning me:null). Clear the stale session and go to login.
      Cookie.remove('token')
      window.location = '/'
    }
  }

  if (!user) runQuery()

  return { user }
}
